/**
 * Documenti del portale, vista di tenant.
 *
 * La stessa scheda che sta sulla schermata del cliente, senza il filtro sul cliente: qui si
 * pubblica per tutti e si vede l'insieme. Il taglio per singolo cliente resta sulla sua
 * scheda, dove si sa *chi* è — pubblicare un contratto scegliendo il destinatario da un
 * elenco astratto è il modo per darlo all'azienda sbagliata.
 */
import { createFileRoute } from '@tanstack/react-router';
import { Stack } from '@mantine/core';
import { IconFolders } from '@tabler/icons-react';
import { MaeShell, MaePageHead } from '@/shared/desktop/MaeShell';
import { ClientPortalDocumentsCard } from '@/features/portal/admin/ClientPortalDocumentsCard';
import { PortalNotifyDocumentCard } from '@/features/portal/admin/PortalNotifyDocumentCard';

export const Route = createFileRoute('/_app/admin/portal-documents')({ component: PortalDocumentsAdmin });

function PortalDocumentsAdmin() {
  return (
    <MaeShell>
      <Stack gap={16}>
        <MaePageHead
          title="Documenti del portale"
          sub="Cosa trovano i clienti nell’archivio: condizioni, certificazioni, modulistica."
          icon={<IconFolders size={23} />}
        />
        {/* L'avviso al cliente sta sopra l'elenco perché è una decisione che si prende **prima**
            di pubblicare, non dopo: da spento la pubblicazione resta muta. */}
        <PortalNotifyDocumentCard />
        <ClientPortalDocumentsCard />
      </Stack>
    </MaeShell>
  );
}
